// Animation and Scroll Effects
(function() {
    'use strict';
    // Scroll reveal animation
    function initScrollReveal() {
        const reveals = document.querySelectorAll('.reveal');
        const revealObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) entry.target.classList.add('active');
            });
        }, {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        });
        reveals.forEach((reveal)=>{
            revealObserver.observe(reveal);
        });
    }
    // Add reveal class to elements for scroll animations
    function addRevealClasses() {
        // Add reveal to service cards
        const serviceCards = document.querySelectorAll('.service-card');
        serviceCards.forEach((card)=>card.classList.add('reveal'));
        // Add reveal to timeline items
        const timelineItems = document.querySelectorAll('.timeline-item');
        timelineItems.forEach((item)=>item.classList.add('reveal'));
        // Add reveal to cert cards
        const certCards = document.querySelectorAll('.cert-card');
        certCards.forEach((card)=>card.classList.add('reveal'));
        // Add reveal to FAQ items
        const faqItems = document.querySelectorAll('.faq-item');
        faqItems.forEach((item)=>item.classList.add('reveal'));
        // Add reveal to stats
        const statItems = document.querySelectorAll('.stat-item');
        statItems.forEach((item)=>item.classList.add('reveal'));
        // Add reveal to education cards
        const educationCards = document.querySelectorAll('.education-card');
        educationCards.forEach((card)=>card.classList.add('reveal'));
    }
    // Parallax effect for cyber grid
    function initParallax() {
        const cyberGrid = document.querySelector('.cyber-grid');
        if (cyberGrid) window.addEventListener('scroll', function() {
            const scrolled = window.pageYOffset;
            const rate = scrolled * 0.3;
            cyberGrid.style.transform = `translateY(${rate}px)`;
        });
    }
    // Counter animation for stats
    function animateCounter(element, start, end, duration) {
        const range = end - start;
        const increment = range / (duration / 16);
        let current = start;
        const timer = setInterval(function() {
            current += increment;
            if (increment > 0 && current >= end || increment < 0 && current <= end) {
                current = end;
                clearInterval(timer);
            }
            element.textContent = Math.floor(current) + (element.dataset.suffix || '');
        }, 16);
    }
    function initCounters() {
        const statNumbers = document.querySelectorAll('.stat-number');
        const counterObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting && !entry.target.classList.contains('counted')) {
                    entry.target.classList.add('counted');
                    const text = entry.target.textContent;
                    const value = parseInt(text.replace(/\D/g, ''));
                    const suffix = text.replace(/[0-9]/g, '');
                    entry.target.dataset.suffix = suffix;
                    entry.target.textContent = '0';
                    animateCounter(entry.target, 0, value, 2000);
                }
            });
        }, {
            threshold: 0.5
        });
        statNumbers.forEach((stat)=>{
            counterObserver.observe(stat);
        });
    }
    // Initialize animations when DOM is ready
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() {
        addRevealClasses();
        initScrollReveal();
        initParallax();
        initCounters();
    });
    else {
        addRevealClasses();
        initScrollReveal();
        initParallax();
        initCounters();
    }
})();

//# sourceMappingURL=alooshd.com.cc36c732.js.map
